import { Divider, Flex, Typography } from "antd"

import Images from "../../Images"
import { PaymentDefaultTag } from "./PaymentDefaultTag"

const { Text } = Typography

const ShopifyDefaultRow = ({ iconSize }) => {
  return (
    <div>
      <Divider style={{ margin: "0px 0px" }} />
      <Flex justify="space-between" align="center" style={{ marginTop: 8 }}>
        <Flex gap={8}>
          <img
            src={Images["shopify"]}
            alt="Shopify"
            {...(iconSize && { width: iconSize, height: iconSize })}
          />
          <Text className="text-min">Shopify</Text>
          <PaymentDefaultTag />
        </Flex>
      </Flex>
      <Divider style={{ margin: "12px 0px" }} />
    </div>
  )
}

export default ShopifyDefaultRow
